import * as IoC from 'typescript-ioc';
import { JobType } from '../../../../api/jobs.dao';
import { JobConfiguration } from '../../job-configuration';
import { IConnectionsDAO } from '../../../../api/connections.dao';

export class MeetingConnectionsUpdateBulkJob extends JobConfiguration {
    public readonly type = JobType.MeetingOperatorsUpdateBulk;
    public readonly name = 'Bulk Update Operators';
    public readonly description = 'Meeting Operators Status';

    public async execute(execParams) {
        return IoC.Container.get(IConnectionsDAO).operatorsBulkUpdate(execParams);
    }
}

export default {
    [JobType.MeetingOperatorsUpdateBulk]: MeetingConnectionsUpdateBulkJob
};
